module.exports = __webpack_public_path__ + "static/media/logo.f678ab98.png";